
import useScrollAnimation from '../../../hooks/useScrollAnimation';

const CtaSection = () => {
  const { ref: sectionRef, isVisible } = useScrollAnimation({ threshold: 0.2 });

  return (
    <section ref={sectionRef} className="py-12 sm:py-24 px-4 sm:px-6 lg:px-12 bg-emerald-700 overflow-hidden">
      <div className="max-w-5xl mx-auto text-center">
        <h2 
          className={`text-2xl sm:text-4xl md:text-5xl font-bold text-white mb-4 sm:mb-6 transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          ¿Quieres Vender tu Coche?
        </h2>
        <p 
          className={`text-sm sm:text-xl text-white/90 mb-6 sm:mb-10 leading-relaxed transition-all duration-700 delay-150 px-2 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          Te damos presupuesto sin compromiso en menos de 2 horas. <strong>Desguace profesional en Gavá</strong> con más de 15 años de experiencia.
        </p>
        <a
          href="tel:+34932932913"
          className={`inline-flex items-center space-x-2 sm:space-x-3 bg-white text-emerald-700 hover:bg-gray-100 px-6 sm:px-10 py-3 sm:py-4 rounded-lg font-bold text-base sm:text-lg transition-all hover:scale-105 shadow-xl whitespace-nowrap duration-700 delay-300 ${
            isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-90'
          }`}
        >
          <span>Llamar: 932 932 913</span>
          <i className="ri-arrow-right-line text-lg sm:text-xl"></i>
        </a>

        <div className="mt-10 sm:mt-16 flex flex-wrap justify-center items-center gap-3 sm:gap-6">
          {[
            { src: 'https://public.readdy.ai/ai/img_res/b36edcd17c5026bc548b0f20575b493a.jpg', alt: 'Coche siniestrado en Gavá' },
            { src: 'https://readdy.ai/api/search-image?query=old%20broken%20compact%20car%20cutout%20isolated%20on%20transparent%20white%20background%20professional%20product%20photography%20high%20quality%20realistic%20three%20quarter%20view%20worn%20vehicle%20studio%20lighting&width=400&height=300&seq=cta-car-002&orientation=landscape', alt: 'Coche averiado en Gavá' },
            { src: 'https://readdy.ai/api/search-image?query=damaged%20suv%20vehicle%20cutout%20isolated%20on%20transparent%20white%20background%20professional%20product%20photography%20high%20quality%20realistic%20front%20angle%20view%20accident%20car%20studio%20lighting&width=400&height=300&seq=cta-car-003&orientation=landscape', alt: 'SUV para desguace en Gavá' },
            { src: 'https://readdy.ai/api/search-image?query=wrecked%20hatchback%20car%20cutout%20isolated%20on%20transparent%20white%20background%20professional%20product%20photography%20high%20quality%20realistic%20side%20view%20damaged%20vehicle%20studio%20lighting&width=400&height=300&seq=cta-car-004&orientation=landscape', alt: 'Coche para chatarra en Gavá' },
          ].map((car, index) => (
            <div 
              key={index}
              className={`relative w-28 h-20 sm:w-48 sm:h-32 transition-all duration-700 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: isVisible ? `${400 + index * 100}ms` : '0ms' }}
            >
              <img
                src={car.src}
                alt={car.alt}
                className="w-full h-full object-contain filter grayscale hover:grayscale-0 transition-all"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CtaSection;
